import React from 'react';
import styles from './choice.module.css';

const buttonClass = (isOn) => `${styles.iconBarBtn} ${isOn ? styles.iconBarBtnOn : ''}`.trim();

/**
 * One bar of text formatting: on / off toggles (italic, underline, strikethrough), a divider, then the alignment as
 * a single choice. Each button keeps its name as tooltip and accessible name.
 */
export const FormatBar = ({ toggles, alignments, alignment, onAlign }) => (
    <div className={styles.iconBar}>
        <div className={styles.iconBarGroup} role="group" aria-label="Text style">
            {toggles.map((toggle) => (
                <button
                    key={toggle.label}
                    type="button"
                    aria-pressed={toggle.isOn}
                    aria-label={toggle.label}
                    title={toggle.label}
                    className={buttonClass(toggle.isOn)}
                    onClick={toggle.onToggle}
                >
                    {toggle.icon}
                </button>
            ))}
        </div>
        <span className={styles.iconBarDivider} aria-hidden="true" />
        <div className={styles.iconBarGroup} role="radiogroup" aria-label="Text alignment">
            {alignments.map((option) => (
                <button
                    key={option.value}
                    type="button"
                    role="radio"
                    aria-checked={option.value === alignment}
                    aria-label={option.label}
                    title={option.label}
                    className={buttonClass(option.value === alignment)}
                    onClick={() => onAlign(option.value)}
                >
                    {option.icon}
                </button>
            ))}
        </div>
    </div>
);
